export const getInstruments = (state) => {
  const securitiesAccounts = state.userInstruments.data.map((el) => {
    return {
      label: el.accountDescr,
      value: el.account,
      favorite: el.favorite,
    };
  });
  let favorite = securitiesAccounts.find((el) => el.favorite === 'Y');

  if (!favorite) {
    [favorite] = securitiesAccounts;
  }

  return { securitiesAccounts, favorite };
};

export const getAllInstruments = (state) => state.userInstruments.data;

export const selectSearchInstruments = (state) =>
  state.userInstruments.data.map((el) => {
    return {
      ...el,
      canTrade: el.canTrade,
      label: `${el.symbol} / ${el.descr} / ${el.exchange}`,
      isFavourite: el.isFavourite,
    };
  });
export const getError = (state) => state.userInstruments.error;
